import { Box, List, ListItem, ListItemText, Typography, useMediaQuery, useTheme } from "@mui/material";

export const TerminosYCondicionesLendia = () => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));

  const font_title = isMobileOrTablet ? 20 : 28;
  const font_text = isMobileOrTablet ? 14 : 18;
  return (
    <>
      <Box mx={isMobileOrTablet ? 4 : 25} my={6}>
        <Typography color={theme?.palette?.primary?.main} textAlign={"center"} fontWeight={700} fontSize={font_title}>
          Términos Y Condiciones Generales De Los Servicios Y Plataforma Lendia
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Este acuerdo establece los términos y condiciones generales (en adelante, "Términos y Condiciones") que
          regulan el uso de los productos y servicios proporcionados por Lendit Group SAPI de CV (en lo sucesivo,
          "Lendit") a través del sitio web https://lendia.mx (el "Sitio Web Lendia") y la plataforma tecnológica (la
          "Plataforma Lendia"). Complementariamente Lendia ha puesto a disposición un Aviso de Privacidad para clientes
          y prospectos en www.lendia.mx/aviso-de-privacidad, que el Usuario debe revisar para entender cómo se manejará
          su información personal. Cualquier individuo que no esté de acuerdo con estos Términos y Condiciones, así como
          con el Aviso de Privacidad de Lendia, los cuales son de carácter obligatorio y vinculante, debe abstenerse de
          utilizar los servicios de Lendia, sus aplicaciones, sitios web y plataformas.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          El Usuario que desee acceder y utilizar las herramientas, aplicaciones y/o software proporcionados por Lendit,
          incluyendo las mencionadas Plataformas Lendia, deberá aceptar estos Términos y Condiciones, así como las
          políticas y principios integrados en este documento. En caso de no estar de acuerdo, el Usuario deberá
          abstenerse de usar la Plataforma Lendia, el Sitio Web Lendia o cualquier otro servicio relacionado.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Al aceptar estos Términos y Condiciones, el Usuario expresa su consentimiento para autenticarse y llevar a
          cabo la contratación, consulta, aclaración y cualquier otra acción relacionada con las herramientas,
          aplicaciones y software que forman parte de la Plataforma Lendia y/o el Sitio Web Lendia, mediante medios
          ópticos, electrónicos, digitales o cualquier otra tecnología acordada por las partes.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          1. Objeto de los Términos y Condiciones
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          El objeto estos Términos y Condiciones es regular el acceso y uso de la Plataforma Lendia y/o el Sitio Web
          Lendia, así como cualquier otro servicio relacionado, incluyendo todo tipo de contenido disponible bajo el
          dominio: clientes@lendia.mx
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          2. Definiciones:
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          A efectos de estos Términos y Condiciones, los siguientes términos tendrán los significados que se les
          atribuyen a continuación:
        </Typography>

        <List
          component="ul"
          sx={{
            listStyleType: "disc",
            pl: 4,
            "& li::marker": {
              color: theme.palette.primary.dark,
              fontWeight: "bold",
              fontSize: font_text,
            },
          }}
        >
          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Cuenta Lendit</strong>: Significa la cuenta personal creada por un Usuario para acceder y
                  utilizar los servicios proporcionados a través de la Plataforma Lendia y el Sitio Web Lendia.
                </>
              }
              primaryTypographyProps={{
                color: theme.palette.primary.dark,
                fontWeight: 400,
                fontSize: font_text,
              }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Usuario</strong>: Se refiere a cualquier persona física, incluyendo personas físicas con
                  actividad empresarial, o persona moral legalmente constituida que acceda, utilice o registre una
                  cuenta en la Plataforma Lendia y/o el Sitio Web Lendia.
                </>
              }
              primaryTypographyProps={{
                color: theme.palette.primary.dark,
                fontWeight: 400,
                fontSize: font_text,
              }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Plataforma Lendia</strong>: Se refiere a las herramientas, aplicaciones, software y servicios
                  ofrecidos por Lendit a través del sitio web https://lendia.mx y sus subdominios.
                </>
              }
              primaryTypographyProps={{
                color: theme.palette.primary.dark,
                fontWeight: 400,
                fontSize: font_text,
              }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Sitio Web Lendia</strong>: Se refiere al sitio web operado por Lendit, ubicado en la URL
                  https://lendia.mx, que proporciona acceso a la Plataforma Lendia.
                </>
              }
              primaryTypographyProps={{
                color: theme.palette.primary.dark,
                fontWeight: 400,
                fontSize: font_text,
              }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Usuario</strong>: Cualquier persona moral legalmente constituida, a través de un apoderado o
                  representante legal que cuente con las facultades suficientes y necesarias, y/o persona física,
                  incluyendo aquellas personas físicas con actividad empresarial que ingresen, realicen un registro,
                  utilicen, la Plataforma Lendia, el Sitio Web Lendia y subdominios, así como las Plataformas Lendia.
                </>
              }
              primaryTypographyProps={{
                color: theme.palette.primary.dark,
                fontWeight: 400,
                fontSize: font_text,
              }}
            />
          </ListItem>
        </List>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          3. Modificaciones:
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          El Usuario reconoce y acepta que Lendit se reserva la facultad de modificar en cualquier momento y sin previo
          aviso, la presentación, el contenido, la funcionalidad, productos y servicios, y cualquier configuración que
          pudiera estar contenida en la Plataforma Lendia, y/o el Sitio Web Lendia y/o Plataformas Lendia. Derivado de
          lo anterior, Lendit en cualquier momento podrá interrumpir, desactivar o cancelar cualquiera de los elementos
          que conforman la Plataforma Lendia, y/o el Sitio Web Lendia y/o Plataformas Lendia o el acceso a los mismos.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          El acceso, uso y/o registro en la Plataforma Lendia y/o el Sitio Web Lendia no implica la creación de una
          relación contractual o cualquier otro tipo de relación legal entre Lendit y el Usuario. El acceso a estas
          plataformas generalmente es gratuito para el Usuario, a excepción de los costos de conexión a internet que
          pueda cobrar el proveedor de servicios contratado por el propio Usuario.
        </Typography>
        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Para contratar los productos y servicios ofrecidos por Lendit, el Usuario debe crear una cuenta proporcionando
          la información solicitada. Esta cuenta se considerará creada una vez que se reciba la aceptación
          correspondiente a través de medios electrónicos, y está sujeta a la aprobación del área de crédito de Lendit y
          al cumplimiento de los requisitos que esta determine.
        </Typography>
        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          La Plataforma Lendia y el Sitio Web Lendia están destinados a personas con capacidad legal para contratar, ya
          sea en su propio nombre o en representación de una persona moral. Lendit no asume ninguna responsabilidad en
          caso de que este requisito no se cumpla. En el caso de que el Usuario actúe en representación de una persona
          moral, debe contar con los poderes suficientes y necesarios para obligar a dicha entidad según lo establecido
          en estos términos y conforme a la legislación aplicable.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Estas plataformas están diseñadas principalmente para Usuarios residentes en los Estados Unidos Mexicanos.
          Lendit no garantiza que la Plataforma Lendia y/o el Sitio Web Lendia cumplan completamente con las leyes de
          otros países. Por lo tanto, si el Usuario accede a estas plataformas desde otra jurisdicción, lo hace bajo su
          propia responsabilidad y debe asegurarse de que su uso cumpla con las leyes locales aplicables. Lendit no se
          responsabiliza por cualquier consecuencia que pueda derivarse de tal acceso. Lendit se reserva el derecho de
          administrar y gestionar la Plataforma Lendia y el Sitio Web Lendia, ya sea de manera directa o a través de
          terceros, sin que esto afecte los términos y condiciones establecidos en este documento.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          4. Responsabilidades del Usuario
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          El Usuario se compromete a:
        </Typography>

        <List
          component="ul"
          sx={{
            listStyleType: "disc",
            pl: 4,
            "& li::marker": {
              color: theme.palette.primary.dark,
              fontWeight: "bold",
              fontSize: font_text,
            },
          }}
        >
          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Proporcionar información veraz, precisa y completa </strong> durante el proceso de registro y
                  en cualquier otra interacción con Lendit.
                </>
              }
              primaryTypographyProps={{
                color: theme.palette.primary.dark,
                fontWeight: 400,
                fontSize: font_text,
              }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Mantener actualizada la información de su cuenta, </strong> incluyendo datos de contacto y
                  financieros.
                </>
              }
              primaryTypographyProps={{
                color: theme.palette.primary.dark,
                fontWeight: 400,
                fontSize: font_text,
              }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>
                    Utilizar la Plataforma Lendia y el Sitio Web Lendia de manera responsable y conforme a la ley,{" "}
                  </strong>{" "}
                  cumpliendo con los presentes Términos y Condiciones.
                </>
              }
              primaryTypographyProps={{
                color: theme.palette.primary.dark,
                fontWeight: 400,
                fontSize: font_text,
              }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Abstenerse de usar la plataforma para actividades ilegales o fraudulentas,</strong> o
                  cualquier acción que pueda perjudicar a terceros o dañar la reputación de Lendit.
                </>
              }
              primaryTypographyProps={{
                color: theme.palette.primary.dark,
                fontWeight: 400,
                fontSize: font_text,
              }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Respetar los derechos de propiedad intelectual</strong> de Lendit y de terceros.
                </>
              }
              primaryTypographyProps={{
                color: theme.palette.primary.dark,
                fontWeight: 400,
                fontSize: font_text,
              }}
            />
          </ListItem>
        </List>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          5. Datos Personales
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          El Usuario debe completar los formularios con información personal y financiera de manera precisa, exacta y
          veraz, incluyendo los denominados “Datos Personales” según la regulación aplicable. El Usuario asume la
          obligación de mantener actualizados estos Datos Personales y de obtener el consentimiento expreso de los
          titulares de los datos cuando sea necesario o cuando Lendit lo requiera.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Lendit podrá emplear diversos métodos para verificar la identidad de sus Usuarios. Lendit no se hace
          responsable de la certeza de los Datos Personales proporcionados por los Usuarios, por lo que el Usuario
          garantiza la legalidad, veracidad, exactitud, vigencia y autenticidad de toda la información suministrada,
          incluidos los Datos Personales.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Lendit se reserva el derecho de solicitar o verificar, a través de medios o sitios públicos de internet,
          cualquier comprobante, información y/o datos adicionales para confirmar los Datos Personales, información
          financiera y crediticia. Lendit también puede suspender temporal o definitivamente la cuenta de cualquier
          Usuario cuyos Datos Personales no puedan ser confirmados.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          El Usuario accederá a su cuenta personal ("Cuenta Lendit") mediante su correo electrónico y la contraseña
          elegida ("Clave de Seguridad"). Es responsabilidad del Usuario mantener la confidencialidad de su Clave de
          Seguridad. La Cuenta Lendit es personal, única e intransferible, y no se permite que un mismo Usuario registre
          o posea más de una Cuenta Lendit. Si Lendit detecta cuentas que contengan datos coincidentes o relacionados,
          podrá cancelar, suspender o inhabilitarlas a su discreción.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          El Usuario es responsable de todas las operaciones realizadas en su Cuenta Lendit, ya que el acceso a la misma
          está restringido al uso de su Clave de Seguridad, que debe ser de conocimiento exclusivo del Usuario. El
          Usuario se compromete a notificar a Lendit de inmediato y de forma adecuada cualquier uso no autorizado de su
          Cuenta Lendit o cualquier acceso no autorizado por terceros. Está prohibida la venta, cesión o transferencia
          de la Cuenta Lendit, incluyendo su reputación y calificaciones, bajo cualquier título.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          6. Derecho de Rechazo y Cancelación
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Lendit se reserva el derecho de rechazar o cancelar cualquier solicitud de registro, ya sea durante el proceso
          o incluso después de la autorización de algún producto, sin necesidad de previo aviso, en los siguientes
          casos:
        </Typography>

        <List
          component="ul"
          sx={{
            listStyleType: "disc",
            pl: 4,
            "& li::marker": {
              color: theme.palette.primary.dark,
              fontWeight: "bold",
              fontSize: font_text,
            },
          }}
        >
          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Violación de los Términos y Condiciones</strong>, o de cualquier política interna de Lendit.
                </>
              }
              primaryTypographyProps={{
                color: theme.palette.primary.dark,
                fontWeight: 400,
                fontSize: font_text,
              }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Sospecha de actividades fraudulentas o ilegales</strong>.
                </>
              }
              primaryTypographyProps={{
                color: theme.palette.primary.dark,
                fontWeight: 400,
                fontSize: font_text,
              }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Incapacidad para verificar la identidad del Usuario</strong>, o la autenticidad de la
                  información proporcionada.
                </>
              }
              primaryTypographyProps={{
                color: theme.palette.primary.dark,
                fontWeight: 400,
                fontSize: font_text,
              }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>
                    Cualquier otra razón que Lendit considere que pueda comprometer la seguridad o integridad
                  </strong>{" "}
                  de la Plataforma Lendia y el Sitio Web Lendia.
                </>
              }
              primaryTypographyProps={{
                color: theme.palette.primary.dark,
                fontWeight: 400,
                fontSize: font_text,
              }}
            />
          </ListItem>

          <ListItem sx={{ display: "list-item", py: 0 }}>
            <ListItemText
              primary={
                <>
                  <strong>Por decisiones o políticas internas</strong>, sin estar obligado a comunicar o explicar las
                  razones de su decisión y sin que ello genere ningún derecho a indemnización o compensación para el
                  Usuario.
                </>
              }
              primaryTypographyProps={{
                color: theme.palette.primary.dark,
                fontWeight: 400,
                fontSize: font_text,
              }}
            />
          </ListItem>
        </List>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          7. Privacidad de la Información
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Para acceder a los productos y servicios ofrecidos por Lendit, los Usuarios deben proporcionar ciertos datos
          personales y financieros. Esta información se procesa y almacena en servidores o medios magnéticos que cuentan
          con estándares adecuados de seguridad y protección, tanto físicos como tecnológicos. Para más detalles sobre
          la privacidad y protección de los Datos Personales, el Usuario puede consultar el Aviso de Privacidad
          disponible en el Portal de Proveedores.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          8. Usuarioón
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          El acceso y uso de la Plataforma Lendia y/o el Sitio Web Lendia confiere al visitante la condición de Usuario,
          lo cual implica la aceptación de estos Términos y Condiciones y sus futuras modificaciones, sin perjuicio de
          la aplicación de las leyes vigentes. Por ello, se considera que los términos están aceptados desde el momento
          en que se accede a dichas plataformas. Se recomienda al Usuario revisar periódicamente estos Términos y
          Condiciones para mantenerse informado sobre posibles actualizaciones.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Es responsabilidad del Usuario utilizar la Plataforma Lendia y el Sitio Web Lendia de acuerdo con su diseño y
          propósito. Queda prohibido el uso de software que automatice la interacción o descarga de contenidos o
          servicios ofrecidos a través de estas plataformas. Asimismo, el Usuario se compromete a utilizar la
          información, contenidos y servicios proporcionados de manera lícita, sin contravenir estos Términos y
          Condiciones, la moral o el orden público. Además, debe abstenerse de realizar cualquier acción que pueda
          afectar los derechos de terceros o perjudicar el funcionamiento de la Plataforma Lendia o el Sitio Web Lendia.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          9. Uso de Cookies y Herramientas Tecnológicas de Terceros
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          El acceso, navegación y uso del Sitio Web Lendia y de la Plataforma Lendia pueden implicar la utilización de
          cookies y herramientas tecnológicas proporcionadas por Lendit o por terceros. Estas herramientas nos permiten
          analizar nuestros servicios, la información proporcionada por los Usuarios y optimizar la experiencia en
          nuestras plataformas. Las cookies son pequeñas cantidades de información almacenadas en el navegador o
          dispositivo del Usuario, que pueden recoger datos sobre las preferencias del usuario y su interacción con el
          sitio.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          La información recopilada a través de cookies y otras herramientas tecnológicas se utiliza para mejorar la
          Plataforma Lendia y el Sitio Web Lendia, detectar errores y comprender mejor las necesidades de los Usuarios
          para ofrecer servicios y contenidos de mayor calidad.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Si el Usuario desea deshabilitar el uso de cookies, debe seguir el procedimiento especificado en nuestra
          política de cookies, disponible en el Sitio Web Lendia. Los pasos para desactivar cookies pueden variar según
          el navegador, por lo que se sugiere consultar las instrucciones proporcionadas por el desarrollador del
          navegador. Es importante tener en cuenta que, al desactivar las cookies, algunas funciones de la Plataforma
          Lendia o el Sitio Web Lendia podrían quedar inhabilitadas.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Es posible que estas políticas sobre el uso de cookies cambien o se actualicen en el futuro. Por lo tanto, se
          recomienda revisar estas actualizaciones periódicamente, tanto en los Términos y Condiciones como en el Sitio
          Web Lendia, para estar adecuadamente informado sobre el uso y propósito de las cookies al utilizar nuestras
          plataformas.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          10. Enlaces a Sitios Externos y Contenidos de Terceros
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          La Plataforma Lendia y/o el Sitio Web Lendia pueden incluir enlaces, contenidos, servicios o funcionalidades
          de otros sitios de internet que pertenecen o son gestionados por terceros, tales como imágenes, videos,
          comentarios y motores de búsqueda, entre otros. Estos enlaces y contenidos tienen como objetivo mejorar la
          experiencia del Usuario al utilizar la Plataforma Lendia y el Sitio Web Lendia, y no deben interpretarse como
          una sugerencia, recomendación o invitación para utilizar sitios externos.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Lendit no controla ni revisa el contenido de los sitios externos enlazados desde la Plataforma Lendia o el
          Sitio Web Lendia, ni se responsabiliza de los productos, servicios, contenidos o cualquier otro material
          disponible en dichos sitios. Además, Lendit no garantiza la disponibilidad, precisión, veracidad, validez o
          legalidad de la información contenida en estos sitios externos. Por lo tanto, Lendit no asume ninguna
          responsabilidad por los daños o perjuicios que puedan derivarse del acceso o uso de los contenidos, productos
          o servicios disponibles en sitios web no gestionados por Lendit, a los que se pueda acceder a través de la
          Plataforma Lendia y/o el Sitio Web Lendia.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Para los Usuarios o terceros que deseen publicar un enlace web desde una página externa hacia la Plataforma
          Lendia y/o el Sitio Web Lendia, se deben considerar los siguientes aspectos:
        </Typography>

        <List
          component="ul"
          sx={{
            listStyleType: "disc",
            pl: 4,
            "& li::marker": {
              color: theme.palette.primary.dark,
              fontWeight: "bold",
              fontSize: font_text,
            },
          }}
        >
          {[
            "No está permitida la reproducción, total o parcial, de los contenidos o servicios disponibles en la Plataforma Lendia y/o el Sitio Web Lendia sin la autorización expresa de Lendit.",
            "No se permitirán declaraciones falsas, inexactas o incorrectas sobre la Plataforma Lendia, el Sitio Web Lendia o sobre Lendit, ni sobre sus contenidos, productos o servicios. Lendit se reserva el derecho de restringir el acceso a su plataforma a cualquier persona que incurra en estas prácticas.",
          ].map((text, index) => (
            <ListItem key={index} sx={{ display: "list-item", py: 0 }}>
              <ListItemText
                primaryTypographyProps={{ color: theme.palette.primary.dark, fontWeight: 400, fontSize: font_text }}
                primary={text}
              />
            </ListItem>
          ))}
        </List>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          El establecimiento de un enlace hacia la Plataforma Lendia y/o el Sitio Web Lendia desde cualquier sitio
          externo no implica la existencia de ninguna relación entre Lendit y el sitio desde el cual se realiza el
          enlace, ni el conocimiento o aprobación de Lendit respecto a los contenidos, productos o servicios ofrecidos
          en el sitio externo.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          11. Recopilación y Uso de Datos de Geolocalización
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Al seleccionar la opción “Permitir uso de mi ubicación” en la Plataforma Lendia y/o el Sitio Web Lendia, el
          Usuario otorga su consentimiento expreso para que Lendit recopile las coordenadas geográficas de latitud y
          longitud, o "Geolocalización", conforme a la normativa aplicable. Esto incluye el uso del dispositivo que
          permite acceder a internet y que puede ser utilizado para celebrar contratos y realizar operaciones
          relacionadas con los servicios y productos de Lendit.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          En situaciones donde el Usuario realice contratos o transacciones no presenciales desde un dispositivo que no
          puede proporcionar coordenadas geográficas mediante GPS, Lendit obtendrá estas coordenadas de forma aproximada
          utilizando la dirección de protocolo de Internet (IP) proporcionada por el dispositivo del Usuario.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Las coordenadas geográficas obtenidas a través del GPS o basadas en la dirección IP se recopilan una vez que
          el Usuario ha otorgado su consentimiento, de acuerdo con la regulación aplicable en materia de protección de
          datos.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          12. Propiedad Intelectual e Industrial
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Lendit, ya sea en calidad de titular o como cesionaria, posee todos los derechos de propiedad intelectual e
          industrial sobre la Plataforma Lendia, el Sitio Web Lendia y/o las Plataformas Lendia, incluyendo sus
          interfaces y diseños gráficos, el código fuente que hace posible su funcionamiento, así como las imágenes,
          archivos de audio o video, logotipos, marcas, combinaciones de colores, estructuras, diseños y demás elementos
          distintivos. Estos derechos están protegidos por la legislación mexicana en materia de propiedad intelectual e
          industrial, así como por los tratados internacionales aplicables.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Por lo tanto, queda estrictamente prohibida la reproducción, distribución o difusión de los contenidos de la
          Plataforma Lendia, el Sitio Web Lendia y/o las Plataformas Lendia con fines comerciales, en cualquier formato
          y a través de cualquier medio, sin la previa autorización escrita de Lendit.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Asimismo, el Usuario se compromete a no suprimir, alterar o manipular ningún elemento, archivo o contenido de
          la Plataforma Lendia, el Sitio Web Lendia y/o las Plataformas Lendia. En ningún caso se permitirá realizar
          actos destinados a vulnerar la seguridad de los sistemas, archivos o bases de datos protegidos, ya sea
          mediante acceso restringido con usuario y contraseña o de cualquier otra forma sin los permisos necesarios
          para visualizar, editar o manipular dichos contenidos.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Si el Usuario o un tercero considera que alguno de los contenidos de la Plataforma Lendia, el Sitio Web Lendia
          y/o las Plataformas Lendia infringe derechos de propiedad industrial o intelectual, deberá comunicarlo
          inmediatamente a Lendit a través del correo electrónico proporcionado en el Sitio Web Lendia:
          clientes@lendia.mx
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          13. Violaciones de Seguridad al Sistema y Acceso No Autorizado a Bases de Datos
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Se prohíbe estrictamente cualquier acción o uso de dispositivos, software u otros medios destinados a
          interferir con las actividades y operaciones de Lendit, así como con sus bases de datos. Cualquier intento de
          intromisión, actividad ilegal o contraria a las leyes, incluidos los derechos de propiedad intelectual y las
          prohibiciones establecidas en estos términos, será responsabilidad de quien las realice. Estas acciones pueden
          resultar en sanciones legales y la obligación de indemnizar a Lendit por los daños y perjuicios ocasionados.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          14. Suspensión de Operaciones
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Sin perjuicio de otras medidas, Lendit se reserva el derecho de advertir, suspender temporalmente o
          inhabilitar de manera definitiva la Cuenta Lendit de un Usuario o cualquier publicación, así como de tomar las
          acciones que considere necesarias y/o suspender la prestación de sus productos y servicios en los siguientes
          casos:
        </Typography>

        <List
          component="ul"
          sx={{
            listStyleType: "disc",
            pl: 4,
            "& li::marker": {
              color: theme.palette.primary.dark,
              fontWeight: "bold",
              fontSize: font_text,
            },
          }}
        >
          {[
            "Violación de leyes o de los Términos y Condiciones, así como de otras políticas de Lendit.",
            "Incumplimiento de las obligaciones del Usuario.",
            "Comportamiento fraudulento o doloso según el criterio de Lendit.",
            "Imposibilidad de verificar la identidad del Usuario o la detección de información errónea o falsa proporcionada por el mismo.",
            "Publicaciones o acciones que puedan generar responsabilidad para el Usuario que las realizó, según lo determine Lendit.",
          ].map((text, index) => (
            <ListItem key={index} sx={{ display: "list-item", py: 0 }}>
              <ListItemText
                primaryTypographyProps={{ color: theme.palette.primary.dark, fontWeight: 400, fontSize: font_text }}
                primary={text}
              />
            </ListItem>
          ))}
        </List>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          En cualquiera de estos casos, Lendit podrá proceder a la suspensión o inhabilitación de la cuenta y/o a la
          eliminación de publicaciones, así como a la suspensión de los servicios sin previo aviso.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          15. Interrupciones y Fallas Técnicas en el Sistema
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Lendit no se responsabiliza por daños, perjuicios o pérdidas que el Usuario pueda experimentar debido a fallas
          en el Sitio Web Lendia y/o las Plataformas Lendia, en el servidor o en la conexión a Internet. Asimismo,
          Lendit no será responsable por la posible infección de virus en los equipos del Usuario/Cliente como resultado
          del acceso, uso o exploración de la Plataforma Lendia y/o el Sitio Web Lendia, o debido a cualquier
          transferencia de datos, archivos, imágenes, textos, audios u otra información a través de medios electrónicos.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Los Usuarios no podrán atribuir a Lendit responsabilidad alguna ni exigir compensación por lucro cesante
          derivado de dificultades técnicas o interrupciones en la disponibilidad de la Plataforma Lendia y/o el Sitio
          Web Lendia, ni por problemas en la conexión a Internet. Lendit no garantiza el acceso continuo e
          ininterrumpido a sus plataformas. El sistema puede estar temporalmente no disponible debido a dificultades
          técnicas, fallas en Internet, u otras circunstancias fuera del control de Lendit; en tales situaciones, Lendit
          hará todo lo posible por restablecer el servicio a la brevedad, sin que ello implique asumir responsabilidad
          alguna.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Lendit tampoco se responsabiliza por cualquier error u omisión en el contenido de la Plataforma Lendia y/o el
          Sitio Web Lendia y/o Plataformas Lendia.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          16. Consultas de Información Crediticia, Financiera, e Información de Carácter Personal
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          En cuanto a la autorización para solicitar información personal, crediticia y financiera, según corresponda,
          la persona física, incluyendo al Usuario persona física con actividad empresarial y/o apoderado y/o
          representante legal de la persona moral, declara lo siguiente:
        </Typography>

        <List
          component="ul"
          sx={{
            listStyleType: "disc",
            pl: 4,
            "& li::marker": {
              color: theme.palette.primary.dark,
              fontWeight: "bold",
              fontSize: font_text,
            },
          }}
        >
          {[
            "Bajo protesta de decir verdad, manifiesto que la información proporcionada en este documento es veraz. En caso de que se demuestre lo contrario, Lendit Group SAPI de CV y/o sus Socios Estratégicos y/o Comerciales estarán libres de cualquier responsabilidad derivada de controversias relacionadas con esta declaración.",
            "En caso de que la solicitante sea una persona moral, declaro, bajo protesta de decir verdad, que los poderes de mi representante legal y/o apoderado, a la fecha de esta autorización, no han sido revocados, limitados ni modificados de ninguna manera.",
            "Autorizo expresamente a Lendit Group SAPI de CV y/o sus Socios Estratégicos y/o Comerciales, a través de sus representantes autorizados, a realizar investigaciones sobre mi comportamiento crediticio en las sociedades de información crediticia que consideren pertinentes.",
          ].map((text, index) => (
            <ListItem key={index} sx={{ display: "list-item", py: 0 }}>
              <ListItemText
                primaryTypographyProps={{ color: theme.palette.primary.dark, fontWeight: 400, fontSize: font_text }}
                primary={text}
              />
            </ListItem>
          ))}
        </List>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Asimismo, declaro que estoy informado sobre la naturaleza y alcance de la información tributaria y financiera
          que se solicitará, que incluye constancias de identificación fiscal, declaraciones fiscales, facturas, listado
          de contribuyentes, ingresos, egresos, clientes, proveedores, entre otros. Acepto el uso que Lendit Group SAPI
          de CV ("Lendit") hará de esta información y consiento que Lendit pueda realizar consultas periódicas sobre mi
          historial crediticio, información financiera y personal, con el consentimiento expreso de las personas físicas
          involucradas o de la entidad que represento, según corresponda. Esta autorización será válida mientras dure la
          relación jurídica y comercial con Lendit, incluyendo para efectos de control y cumplimiento del artículo 28 de
          la Ley para regular a las Sociedades de Información Crediticia y de la Ley Federal de Protección de Datos
          Personales en Posesión de los Particulares.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Igualmente, autorizo el uso y conservación de las denominadas "Contraseña" o "CIEC", así como de claves,
          contraseñas y cualquier otra información necesaria para acceder a los datos proporcionados por el Servicio de
          Administración Tributaria (SAT), ya sea que estos datos correspondan al Usuario o a la entidad que representa.
          Esto incluye la información personal, como la constancia de la "Clave Única de Registro de Población" o
          "CURP". Esta información se utilizará para los siguientes fines y se conservará para la prestación de los
          servicios y productos de Lendit, directamente o a través de un tercero:
        </Typography>

        <List
          component="ul"
          sx={{
            listStyleType: "disc",
            pl: 4,
            "& li::marker": {
              color: theme.palette.primary.dark,
              fontWeight: "bold",
              fontSize: font_text,
            },
          }}
        >
          {[
            "Consultar los antecedentes crediticios en cualquier sociedad de información crediticia.",
            "Consultar información crediticia y de transacciones en cualquier institución bancaria.",
            "Verificar la calidad y vigencia de la información proporcionada por los Usuarios en cualquier sitio de internet o medio público.",
            "Consultar la información registrada en el Servicio de Administración Tributaria, incluyendo datos de identificación, domicilio fiscal, sucursales y establecimientos, características fiscales, facturas emitidas y otra información complementaria.",
          ].map((text, index) => (
            <ListItem key={index} sx={{ display: "list-item", py: 0 }}>
              <ListItemText
                primaryTypographyProps={{ color: theme.palette.primary.dark, fontWeight: 400, fontSize: font_text }}
                primary={text}
              />
            </ListItem>
          ))}
        </List>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Lendit informa que los datos y la información consultada del Usuario pueden ser transferidos, dentro y fuera
          del país, sin necesidad de autorización previa, a cualquier tercero que mantenga una relación jurídica con
          Lendit en virtud de la prestación de servicios.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Declaro que conozco la información que se solicita, el uso que se le dará y su conservación en un medio
          seguro. Autorizo posibles consultas periódicas con una vigencia de al menos tres años o mientras dure la
          relación jurídica.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Finalmente, acepto expresamente que este archivo electrónico y/o medio electrónico y/o mensaje de datos es
          propiedad de Lendit Group SAPI de CV. Reconozco también que la declaración realizada por medios electrónicos
          constituye la firma electrónica de quien la realiza, otorgando a los documentos digitales o técnicos los
          mismos efectos legales que tienen los documentos firmados físicamente, con pleno valor probatorio.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          17. Limitación de Responsabilidad
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Lendit, sus directivos, empleados y afiliados no serán responsables por daños indirectos, incidentales,
          especiales, punitivos o consecuentes, incluyendo, sin limitación, pérdidas de ingresos, beneficios, datos,
          uso, fondo de comercio u otras pérdidas intangibles, que resulten de:
        </Typography>

        <List
          component="ul"
          sx={{
            listStyleType: "disc",
            pl: 4,
            "& li::marker": {
              color: theme.palette.primary.dark,
              fontWeight: "bold",
              fontSize: font_text,
            },
          }}
        >
          {[
            "El uso o la imposibilidad de uso de la Plataforma Lendia o el Sitio Web Lendia.",
            "El acceso no autorizado a o la alteración de las transmisiones o datos del Usuario.",
            "Declaraciones o conductas de terceros en la plataforma.",
            "Cualquier otro asunto relacionado con la plataforma.",
          ].map((text, index) => (
            <ListItem key={index} sx={{ display: "list-item", py: 0 }}>
              <ListItemText
                primaryTypographyProps={{ color: theme.palette.primary.dark, fontWeight: 400, fontSize: font_text }}
                primary={text}
              />
            </ListItem>
          ))}
        </List>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          18. Propiedad Intelectual de Terceros
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Lendit no posee ni controla el contenido de terceros que pueda estar disponible a través de la Plataforma
          Lendia o el Sitio Web Lendia. El uso de dicho contenido es responsabilidad exclusiva del Usuario, y Lendit no
          garantiza la exactitud, veracidad o idoneidad de estos contenidos. Cualquier contenido de terceros que pueda
          infringir derechos de propiedad intelectual debe ser reportado a Lendit para su evaluación y posible
          eliminación.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          19. Comunicaciones Electrónicas
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          El Usuario acepta recibir comunicaciones electrónicas de Lendit, que pueden incluir correos electrónicos,
          mensajes de texto, notificaciones dentro de la plataforma y otros medios electrónicos. Estas comunicaciones
          pueden contener información sobre actualizaciones de la plataforma, ofertas promocionales y otros avisos
          relacionados con los servicios. El Usuario tiene la opción de dejar de recibir ciertas comunicaciones
          siguiendo las instrucciones que se proporcionan en dichos mensajes.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          20. Cláusula de Seguridad
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Lendit implementa medidas de seguridad razonables para proteger la información del Usuario y garantizar la
          seguridad de la Plataforma Lendia y el Sitio Web Lendia. Estas medidas pueden incluir, entre otras, la
          encriptación de datos, el uso de firewalls y controles de acceso. Sin embargo, Lendit no puede garantizar que
          estas medidas de seguridad sean completamente infalibles y, por lo tanto, no se responsabiliza por posibles
          violaciones de seguridad que puedan ocurrir.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          21. Cláusula de No Renuncia
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          La falta de ejercicio o la aplicación parcial de cualquier derecho o disposición de estos Términos y
          Condiciones por parte de Lendit no constituirá una renuncia a dicho derecho o disposición. Cualquier renuncia
          a una disposición de estos Términos y Condiciones solo será efectiva si se realiza por escrito y está firmada
          por un representante autorizado de Lendit.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          22. Independencia de Cláusulas
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          En caso de que alguna disposición de estos Términos y Condiciones sea declarada inválida o inaplicable por un
          tribunal competente, las demás disposiciones seguirán siendo válidas y aplicables. La disposición inválida o
          inaplicable será reemplazada por una disposición válida y aplicable que se acerque lo más posible a la
          intención original de la disposición afectada.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          23. Indemnización
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          El Usuario se compromete a indemnizar y mantener indemne a Lendit, sus socios estratégicos y/o comerciales,
          empresas controladas, directivos, administradores, representantes y empleados, frente a cualquier reclamo o
          demanda de terceros que surja de las actividades realizadas por el Usuario en la Plataforma Lendia y/o el
          Sitio Web Lendia, o por el incumplimiento de los Términos y Condiciones y demás políticas de Lendit. Esto
          incluye, sin limitarse a, la violación de leyes o derechos de terceros, así como los costos y honorarios de
          abogados en una cantidad razonable.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          24. Domicilio
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Ciudad de México, en Calle Arquímedes 15, Polanco, Polanco V Secc, Miguel Hidalgo, 11560.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          25. Enmiendas
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Lendit se reserva el derecho de modificar estos Términos y Condiciones en cualquier momento. Cualquier cambio
          será efectivo inmediatamente después de su publicación en el Sitio Web Lendia. Es responsabilidad del Usuario
          revisar periódicamente los Términos y Condiciones para estar al tanto de posibles modificaciones. El uso
          continuo de la plataforma por parte del Usuario después de la publicación de dichas modificaciones constituye
          la aceptación de los nuevos términos.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          26. Legislación y Jurisdicción Aplicable
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Este acuerdo se regirá en todos sus aspectos por las leyes vigentes en los Estados Unidos Mexicanos. En
          particular, respecto a los mensajes de datos, la contratación y el comercio electrónico, se aplicará la
          legislación federal correspondiente. Cualquier controversia que surja en relación con este acuerdo, su
          existencia, validez, interpretación, alcance o cumplimiento, será resuelta conforme a las leyes aplicables y
          ante los tribunales competentes. Para la interpretación, cumplimiento y ejecución de este contrato, las partes
          se someten expresamente a la jurisdicción de los tribunales federales competentes de la Ciudad de México,
          renunciando a cualquier otro fuero que pudiera corresponderles debido a su domicilio presente o futuro.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          27. Vigencia y Terminación:
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Los presentes Términos y Condiciones permanecerán en vigor mientras el Usuario utilice la Plataforma Lendia o
          el Sitio Web Lendia. Lendit se reserva el derecho de dar por terminada la relación con el Usuario y cancelar
          su cuenta en cualquier momento, con o sin motivo, previa notificación al Usuario. El Usuario también podrá
          cerrar su cuenta en cualquier momento.
        </Typography>
      </Box>
    </>
  );
};
